import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=906cceee&scoped=true&"
import script from "./EventsList.vue?vue&type=script&lang=ts&"
export * from "./EventsList.vue?vue&type=script&lang=ts&"
import style0 from "./EventsList.vue?vue&type=style&index=0&id=906cceee&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906cceee",
  null
  
)

export default component.exports